import { Collection } from '@api/api';
import { collectionApiClient } from '@api/clients';
import { useCollectionsCount } from '@queries/useCollectionsCount';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';

const limit = 9;

export const fetchCollections = async ({
  pageParam = 0,
}: {
  pageParam?: number;
}): Promise<{ page: number; items: Collection[] }> => {
  const { data } = await collectionApiClient.collectionsGet({
    limit,
    start: pageParam ?? 0,
    sort: 'published_at:DESC',
  });

  return { page: pageParam, items: data };
};

export const useCollections = (): UseInfiniteQueryResult => {
  const { data: collectionsCount } = useCollectionsCount();
  const totalPages = Math.ceil(collectionsCount / limit);

  return useInfiniteQuery(['collections', {}], fetchCollections, {
    getNextPageParam: (lastPage, allPages) => {
      return allPages.length !== totalPages ? lastPage.page + limit : false;
    },
  });
};
